import React from "react";

const IconOptions = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      {...props}
    >
      <rect width={32} height={32} fill="#E3E6FA" rx={8} />
      <circle
        cx={24}
        cy={16}
        r={2}
        fill="#4F4FFF"
        transform="rotate(180 24 16)"
      />
      <circle
        cx={16}
        cy={16}
        r={2}
        fill="#4F4FFF"
        transform="rotate(180 16 16)"
      />
      <circle
        cx={8}
        cy={16}
        r={2}
        fill="#4F4FFF"
        transform="rotate(180 8 16)"
      />
    </svg>
  );
};

export default IconOptions;
